import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Post from './../models/Post';


export function getPosts(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_LIST,
        params: params,
        parser: postsDataParser,
    }).get();
}

export function getPostDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_DETAIL,
        endpointParams: { id },
        parser: (data) => new Post(data.data),
    }).get();
}

export function createPostDetail(post) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_ACTION,
        parser: (data) => new Post(data.post),
    }).post(post.export());
}

export function updatePostDetail(post) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_ACTION,
        // endpointParams: { id: post.id },
        parser: (data) => new Post(data.post),
    }).put(post.export());
}

export function deletePostDetail(post) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_DETAIL,
        endpointParams: { id: post.id },
        // parser: (data) => new Post(data.post),
    }).delete();
}

export function createPostTranslate(post) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_TRANSLATE_CREATE,
    }).post(post.export(true).translate());
}

export function updatePostTranslate(post) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_TRANSLATE_UPDATE,
    }).put(post.export(true).translate());
}

export function deletePostTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.POST_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const postsDataParser = (data) => ({
    posts: (data.data.result || []).map(item => new Post(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
});


